import { EVENT_MANAGEMENT_BROWSER_ROUTES } from "@features/EventManagement/integration/browser.routes";
import { STATIC_COURSE_ASSIGN_BROWSER_ROUTES } from "@features/CourseAssign/integration/browser.routes";

export const BROWSER_ROUTES = {
	// Auth routes
	LOGIN: "/sign-in",
	SIGNUP_VERIFY_OTP: "/sign-up/verify-otp",
	SIGNUP_RESET_PASSWORD: "/sign-up/reset-password",
	VERIFY_EMAIL: "/verify-email",
	FORGET_PASSWORD: "/forget-password",
	VERIFY_OTP: "/verify-otp",
	RESET_PASSWORD: "/reset-password",
	SET_PASSWORD: "/set-password/:token",
	UNAUTHORIZED: "/unauthorized",
	SERVER_ERROR: "/500",
	NOT_FOUND: "/404",
	ABOUT: "/about",
	// Legal routes
	PRIVACY_POLICY: "/privacy-policy",
	TERMS_AND_CONDITIONS: "/terms-and-conditions",
	// Dashboard routes
	DASHBOARD: "/",
	// Sidebar menu routes
	INSTITUTES: "/institutes",
	APPLICATIONS: "/applications",
	APPLICATIONS_SCRUTINY: "/applications/scrutiny",
	APPLICATIONS_SCRUTINIZED: "/applications/scrutinized",
	APPLICATIONS_INSPECTED: "/applications/inspected",
	APPLICATIONS_REJECTED: "/applications/rejected",
	APPLICATIONS_REFERRED_BACK: "/applications/referred-back",
	APPLICATIONS_APPROVED: "/applications/approved",
	APPLICATIONS_PENDING_REJECTION: "/applications/pending-rejection",
	REVIEW_APPLICATIONS: "/applications/review",
	VERIFY_APPLICATION: "/verify-application/:applicationId",
	COMMITTEES: "/committees",
	COMMITTEES_MY: "/committees/comittee",
	COMMITTEES_HISTORY: "/committees/history",
	COMMITTEES_REQUESTS: "/committees/requests",
	CERTIFICATES: "/certificates",
	MEMBERS: "/members",
	APPEALS: "/appeals",
	CALENDAR: "/calendar",
	MANAGE_SESSIONS: "/manage-sessions",
	REPORTS: "/reports",
	EMPLOYEE_ENDORSEMENT: "/employee-endorsement",
	REPORT_MODULE: "/report-module",
	TRACEABILITY: "/traceability",
	APPRENTICESHIP_INDUSTRY: "/apprenticeship/industry",
	APPRENTICESHIP_STATISTICS: "/apprenticeship/statistics",
	APPRENTICESHIP_APPRENTICES: "/apprenticeship/apprentices",
	APPRENTICESHIP_OUTCOMES: "/apprenticeship/outcomes",
	COURSE_BUILDER: "/course-builder",
	COURSE_BUILDER_EQUIPMENT: "/course-builder/equipment",
	COURSE_BUILDER_LABS: "/course-builder/labs",
	COURSE_BUILDER_COURSES: "/course-builder/add-courses-details",
	CHALLAN: "/challan",
	EQUIPMENTS: "/equipments",
	LABS: "/labs",
	COURSES_DETAILS: "/courses/details",
	/** Institute portal — public course catalog (no auth). */
	PUBLIC_COURSE_CATALOG_TECHNICAL: "/courses-technical",
	PUBLIC_COURSE_CATALOG_VOCATIONAL: "/courses-vocational",
	// Inspection routes (existing - for convener/member inspection)
	INSPECTION: "/inspection/:applicationId",
	INSPECTION_MEMBER: "/inspection/:applicationId/member/:memberId",
	INSPECTION_CONVENER: "/inspection/:applicationId/convener/:memberId",
	// Director inspection route (new - for director flow without member/convener)
	DIRECTOR_INSPECTION: "/director-inspection/:applicationId",
	MANAGE_USERS: "/manage-users",
	ROLES_AND_PERMISSIONS: "/roles-and-permissions",
	AUDIT_LOGS: "/audit-logs",
	CONFIGURATION: "/configuration",
	CONFIGURATION_COURSE_STREAM: "/configuration?module=course-stream",
	CONFIGURATION_ORGANIZATION_TYPE: "/configuration?module=organization-type",
	CONFIGURATION_COURSE_CONTENT: "/configuration?module=course-content",
	CONFIGURATION_FACULTY_QUALIFICATIONS: "/configuration?module=faculty-qualifications",
	CONFIGURATION_ATTACHMENT_TYPE: "/configuration?module=attachment-type",
	CONFIGURATION_ATTACHMENT_OPTION: "/configuration?module=attachment-option",
	CONFIGURATION_INSTITUTE_FACILITY: "/configuration?module=institute-facility",
	CONFIGURATION_COMPETENCY_POINTS: "/configuration?module=competency-points",
	CONFIGURATION_SECTORS: "/configuration?module=sectors",
	CONFIGURATION_COURSE_SCHEME: "/configuration?module=course-scheme",
	CONFIGURATION_ASSESSMENT_BODY: "/configuration?module=assessment-body",
	// FAQ routes
	FAQ: "/faq",
	FAQ_SECTIONS: "/faq/sections",
	FAQ_ITEMS: "/faq/items/:sectionId",

	// Unauthorized institutes routes
	UNAUTHORIZED_INSTITUTE_REPORTS: "/institutes/unauthorized-institutes",

	...EVENT_MANAGEMENT_BROWSER_ROUTES,
	...STATIC_COURSE_ASSIGN_BROWSER_ROUTES,

	// Application routes
} as const;

export const REGISTER_INSTITUTE_STEP_ROUTES = [
	["institute/basic-info", "institute/address-details", "institute/ownership-details"],
	["building/covered-area", "building/indoor-facilities", "building/outdoor-facilities"],
	["attachments"],
];

export const REVIEW_APPLICATION_STEP_ROUTES = [
	["personal-info", "guardian-info", "contact-info", "address-info", "qualification"],
];

export const EXTERNAL_LINKS = {
	LANDING_PORTAL: "https://tmis-skills.optimusfoxdev.com/",
} as const;
